// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__284OT","buttons":"Footer_buttons__1WPuF"};